var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.bem()},[_c('input',{attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.input}})])}
var staticRenderFns = []

export { render, staticRenderFns }